import styles from "@/styles/global/product-item-full-width.module.scss";
import MyTags from "@/components/global/MyTags";
import Image from "next/image";
import { Rate } from "react-vant";
import { ProductType } from "@/types/product";

interface ProductItemProps {
  product: ProductType;
  isClearance?: boolean;
}

export default function ProductCardFullWidth({ product, isClearance }: ProductItemProps) {
  const priceArr = Number(product.price).toFixed(2).split(".");

  const handleViewDetail = () => {
    window.location.href = product.url;
  };

  return (
    <div
      className={styles["comp-product-item-full-width"]}
      onClick={() => handleViewDetail()}
    >
      <Image
        className={styles["product-image"]}
        src={product.filename || ""}
        alt={product.name}
        width={155}
        height={155}
      />

      <div className={styles["product-info-box"]}>
        <div className={styles["product-tags-box"]}>
          {!!product.inStock && (
            <MyTags {...{ ...product, isSingle: true, position: isClearance ? 'clearance' : undefined }}></MyTags>
          )}
        </div>

        <div className={styles["product-name"]}>
          {product.inStock ? null : (
            <span className={styles["out-of-stock"]}>(OUT OF STOCK)&nbsp;</span>
          )}
          {product.name}
        </div>

        <div className={styles["price-desc"]}>
          <div className={styles["price"]}>
            <span>
              ${priceArr[0]}.<i>{priceArr[1]}</i>
            </span>
          </div>
          {!!(product.normalPrice && product.normalPrice != product.price) && (
            <div className={styles["marking-price"]}>
              <span>${Number(product.normalPrice).toFixed(2)}</span>
            </div>
          )}
        </div>

        {/* 有评论数才展示评分 */}
        <div className={styles["review-box"]}>
          {product.review.total ? (
            <>
              <Rate
                value={product.review.avgRank}
                voidColor={"#dedede"}
                allowHalf
                readOnly
              />
              <div className={styles["review-count"]}>
                ({product.review.total})
              </div>
            </>
          ) : null}
        </div>
      </div>

      {product.promotion && product.promotion.promotionRate ? (
        <div
          className={styles["promotion-rate-box"]}
          style={{
            background: `url('${process.env.IMAGE_DOMAIN}/home/csotd-promotion-bg.svg') no-repeat`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <div className={styles["promotion-rate-number"]}>
            {product.promotion.promotionRate}%
          </div>
          <div className={styles["promotion-rate-text"]}>OFF</div>
        </div>
      ) : null}
    </div>
  );
}
